<template>
    <div
        class="image-container"
        :class="getStoryCircle"
        :style=" {width: `${sizeBorder}px`, height: `${sizeBorder}px`, padding: `${border}px`}"
    >
        <div
            v-if="imageSrc"
            class="profile-image"
            @click="handleClickProfile"
             :style="{'background-image': `url(${imageSrc})`, width: `${size}px`, height: `${size}px`, border: `${border}px solid black`}">
        </div>

        <div
            @click="handleClickProfile"
            class="profile-image--default"
            :style="{ 'font-size': `${fontSize}px`,width: `${size}px`, height: `${size}px`, border: `${border}px solid ${circle ? 'black' : (isExistStory ? 'black' : 'white')}`}"
            v-else
        >
            {{firstLetters}}
        </div>
        <template v-if="streamIcon">
            <div class="live-status">
                <span>
                    <svg width="29" height="29" viewBox="0 0 241 241" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M120.466 240.932C186.998 240.932 240.932 186.998 240.932 120.466C240.932 53.9345 186.998 0 120.466 0C53.9345 0 0 53.9345 0 120.466C0 186.998 53.9345 240.932 120.466 240.932Z" fill="#FF4F6B"/>
                        <path d="M120.469 0C115.234 0 110.077 0.337007 105.016 0.988007C164.171 8.59601 210.03 59.276 210.03 120.466C210.03 181.656 164.17 232.336 105.016 239.944C110.077 240.595 115.234 240.932 120.469 240.932C186.894 240.932 240.936 186.892 240.936 120.466C240.936 54.041 186.895 0 120.469 0Z" fill="#FB2B3A"/>
                        <path d="M208.818 134.76C216.732 85.9403 183.571 39.9485 134.751 32.0344C85.9311 24.1203 39.9389 57.2808 32.0249 106.1C24.1109 154.92 57.2719 200.912 106.092 208.826C154.912 216.74 200.904 183.58 208.818 134.76Z" fill="white"/>
                        <path d="M95.5391 155.84V85.0894C95.5391 77.9234 103.692 73.8074 109.459 78.0614L157.404 113.436C162.135 116.927 162.135 124.001 157.404 127.492L109.459 162.867C103.692 167.123 95.5391 163.006 95.5391 155.84Z" fill="#FF4F6B"/>
                        <path d="M157.404 113.438L109.459 78.0633C103.693 73.8093 95.5391 77.9253 95.5391 85.0913V90.5964C115.648 105.433 115.648 135.5 95.5391 150.337V155.842C95.5391 163.008 103.692 167.124 109.459 162.87L157.404 127.495C162.135 124.003 162.135 116.929 157.404 113.438Z" fill="#FB2B3A"/>
                    </svg>
                </span>
            </div>
        </template>
        <story-view v-if="isShowStory && $store.state.loadedData.getStory"
            @prevUserStory="handleBackNav"    
            @nextUserStory="handleBackNav"
            @close="handleBackNav"
            :start-from-active-index="displayUserStory"
        />
        <app-transition>
            <own-story-menu @close="handleCloseEditStory" v-if="isEditStory"/>
        </app-transition>
    </div>
</template>

<script>
import StoryView from "@/views/app/story/StoryView";
import OwnStoryMenu from "@/views/app/story/OwnStoryMenu";
import {mapActions, mapState} from "vuex";

export default {
    name: "ProfileImage",
    components: {
        StoryView,
        OwnStoryMenu,
    },
    data: () => ({
        isShowStory: false,
        isEditStory: false,
    }),
    props: {
        size: {
            type: [String, Number],
            default: 134
        },
        img: {
            //type: [String, undefined],
            required: true
        },
        isExistStory: {
            type: Boolean,
            default: true
        },
        hasNotWatchedStories: {
            type: Boolean,
            default: false
        },
        border: {
            type: [String, Number],
            default: 6
        },
        id: {
            type: [Number, String],
            default: ''
        },
        includeStories: {
            type: Boolean,
            default: true
        },
        editable: {
            type: Boolean,
            default: false
        },
        username: {
            type: String,
            required: true,
        },
        fontSize: {
            type: Number,
            default: 42,
        },
        displayUserStory: {
            type: Boolean,
            default: false
        },
        circle: {
            type: Boolean,
            default: false
        },
        streamIcon: {
            type: Boolean,
            default: false
        },
        viewProfile: {
            type: Boolean,
            default: false
        },
        viewProfileFrom: {
            type: String,
            default: ''
        },
        viewProfileSlug: {
            type: String,
            default: ''
        },
    },
    computed: {
        ...mapState({
            currentUser: (state) => state.user.user.data,
        }),
        firstLetters() {
            return this.username.slice(0, 2).toUpperCase()
        },
        sizeBorder() {
            return this.size - 0 + (this.border * 2);
        },
        imageSrc() {
            return (typeof this.img !== 'string') ? false : this.img;
        },
        getStoryCircle() {
            if (this.circle) {
                return { 'circle-red': true };
            }

            if (this.isExistStory) {
                if (this.hasNotWatchedStories) {
                    return { 'has-not-watched-stories': true };
                }
                return { 'story-exist': true };
            }

            return {};
        }
    },
    watch: {
        displayUserStory() {
            this.isShowStory = this.displayUserStory;
        }
    },
    methods: {
        showStory() {
            if (this.includeStories) {
                this.isShowStory = true;
                if ('id' in this.$store.state.story.currentStory || this.$store.state.story.currentStory.id !== this.id) {
                    this.getStory({id: this.id})
                }
            }
        },
        handleCloseEditStory() {
            this.isEditStory = false
        },
        handleClickProfile() {
            if (this.editable) {
                this.isEditStory = true
            } else if (this.isExistStory) {
                const ageVerify = this.$core.storyCore.ageVerification(this.currentUser);
                if(!ageVerify) return;
                this.showStory();
            } else if (this.viewProfile) {
                this.$router.push({
                    name: 'otherUser.profile.viewSlug',
                    params: {slug: this.viewProfileSlug, from: this.viewProfileFrom},
                });
            }
            this.$emit('click')
        },
        handleBackNav() {
            if (this.displayUserStory) {
                this.$router.push({
                    name : 'auth.home',
                })
            }
            this.isShowStory = false
        },
        ...mapActions(['getStory']),
    },
    mounted() {

    },
    /*beforeDestroy() {
        this.$store.commit('setStory')
    }*/
}
</script>

<style scoped lang="scss">
@import '@/sass/modules/_variables';

.profile-image {
    border-radius: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: whitesmoke;
    object-fit: cover;

    &--default {
        display: flex;
        border-radius: 50%;
        justify-content: center;
        align-items: center;
        background-color: #141414;
        color: #FE4811;
    }
}

.image-container {
    border-radius: 50%;
    padding-left: 4px;
    padding-top: 4px;
    position: relative;
}

.story-exist {
    background: $grey-background;
}

.has-not-watched-stories {
    background: $accent-background;
}
.circle-red {
    background: linear-gradient(45deg, #ff0000, #ff6666); /* red to light red */
}

.live-status { 
    position: absolute;
    bottom: -17px;
    right: 48px;
    span {
        height: 14px;
        width: 14px;
        display: inline-block;
        border-radius: 100%;
        // background-color: green;
    }
 }
</style>
